import Vue from 'vue'
import Router from 'vue-router'
// Containers
import Full from '@/containers/Full'
// Views
import Invoices from '@/views/Invoices'
import Users from '@/views/Users'
import InvoiceImports from '@/views/InvoiceImports'
import Campaigns from '@/views/Campaigns'
import CreateCampaigns from '@/views/CreateCampaign'
import MobileAppStuff from '@/views/MobileAppStuff'
import Login from '@/views/Login'
import Claims from '@/views/Claims'
import PairRequests from '@/views/PairRequests'
import CustomerAccounts from '@/views/CustomerAccounts'
import CustomerAccountUpload from '@/views/CustomerAccountUpload'
import UserClaimReport from '@/views/UserClaimReport'
import InvoiceUpload from '@/views/InvoiceUpload'
import GenerateClaimReports from '@/views/GenerateClaimReports.vue'
import Banners from '@/views/Banners.vue'
import Notifications from '@/views/Notifications.vue'
// 20-Oct-2018, Luis: Phase2, configuration for invoice list display in APP.
import Configuration from '@/views/Configuration.vue'
import Firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Router)

let router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/login',
      name: 'Info',
      component: Full,
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'invoices',
          name: 'Invoices',
          component: Invoices,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'users',
          name: 'Users',
          component: Users,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'claims',
          name: 'Claims',
          component: Claims,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'pairrequests',
          name: 'PairRequests',
          component: PairRequests,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'invoiceupload',
          name: 'Upload Invoice',
          component: InvoiceUpload,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'invoiceimports',
          name: 'Imports',
          component: InvoiceImports,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'customeraccounts',
          name: 'Customer Accounts',
          component: CustomerAccounts,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'customeraccountupload',
          name: 'Upload Customer Accounts',
          component: CustomerAccountUpload,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'campaigns',
          name: 'Campaigns',
          component: Campaigns,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'createcampaign',
          name: 'CreateCampaign',
          component: CreateCampaigns,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'mobileappstuff',
          name: 'MobileAppStuff',
          component: MobileAppStuff,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'userclaimreport',
          name: 'UserClaimReport',
          component: UserClaimReport,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'generateclaimreports',
          name: 'GenerateClaimReports',
          component: GenerateClaimReports,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'banners',
          name: 'Banners',
          component: Banners,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'notifications',
          name: 'Notifications',
          component: Notifications,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        // 20-Oct-2018, Luis: Phase2, configuration for invoice list display in APP.
        {
          path: 'configuration',
          name: 'Configuration',
          component: Configuration,
          props: true,
          meta: {
            requiresAuth: true
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  console.log('before each, from:' + from.path + ' to:' + to.path)
  let currentUser = Firebase.auth().currentUser
  // if (to.path === '/login' && currentUser) {
  //   next('invoices')
  //   return
  // }
  console.log('current firebase user:' + currentUser)
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth && !currentUser) {
    next('login')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js